import React from 'react';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import LandingPage          from "./components/LandingPage";
import LogInPage            from "./components/LogInPage";
import RegisterPage         from "./components/RegisterPage";
import HomePage             from "./components/HomePage";
import ServiceSelectionPage from "./components/ServiceSelectionPage";
import PoliciesPage         from "./components/PoliciesPage";
import BecomeADriverPage    from "./components/BecomeADriverPage";
import DriverRegisterPage   from "./components/DriverRegisterPage";
import ForgotPasswordPage   from "./components/ForgotPasswordPage";
import DeleteAccountPage    from "./components/DeleteAccount";
import RestaurantsPage      from "./components/RestaurantsPage";
import VacanciesPage        from "./components/VacanciesPage";
import RestaurantMenuPage   from "./components/RestaurantsMenuPage";
import CartPage             from "./components/CartPage";
import SellerRegisterPage   from "./components/SellerRegisterPage";
import OrderTrackingPage from "./components/OrderTrackingPage";
import RateOrderPage from "./components/RateOrderPage";


const App: React.FC = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/"                                    element={<LandingPage />}          />
                <Route path="/logIn"                                element={<LogInPage />}            />
                <Route path="/register"                             element={<RegisterPage />}         />
                <Route path="/forgotPassword"                       element={<ForgotPasswordPage />}   />
                <Route path="/serviceSelection"                     element={<ServiceSelectionPage />} />
                <Route path="/home"                                 element={<HomePage />}             />
                <Route path="/policy"                               element={<PoliciesPage />}         />
                <Route path="/becomeADriverPage"                    element={<BecomeADriverPage />}    />
                <Route path="/driverRegisterPage"                   element={<DriverRegisterPage />}   />
                <Route path="/deleteAccount"                       element={<DeleteAccountPage />}    />
                <Route path="/restaurantMenuPage/:restaurant_id"  element={<RestaurantMenuPage />}      />
                <Route path="/vacanciesPage"  element={<VacanciesPage />}      />
                <Route path="/restaurantsPage/:latitude/:longitude"  element={<RestaurantsPage />}      />
                <Route path="/cart/:restaurant_id"  element={<CartPage />}      />
                <Route path="/cart"  element={<CartPage />}      />
                <Route path="/sellerRegisterPage"  element={<SellerRegisterPage />}      />
                <Route path="/orderTracking"  element={<OrderTrackingPage />}      />
                <Route path="/rateOrderPage"  element={<RateOrderPage />}      />

            </Routes>
        </BrowserRouter>
    );
};

export default App;